export type ValidateError = {
  message: string
}

class ValidationChain {
  private readonly errors: ValidateError[] = []

  constructor(private value: any) {}

  bizNumber = (): this => {
    this.value = this.value.replace(/[^\d]/g, '')

    if (this.value.length !== 10) {
      this.errors.push({ message: '사업자번호는 10자리 숫자로 입력해주세요.' })
    }

    return this
  }

  required = (message: string): this => {
    if (this.value) {
      return this
    }

    this.errors.push({ message })
    return this
  }

  isNumber = (message: string): this => {
    if (!this.value && this.value !== 0) {
      this.errors.push({ message })
    }

    return this
  }

  same = (value: any, message: string): this => {
    if (value !== this.value) {
      this.errors.push({ message })
    }

    return this
  }

  checkbox = (message: string): this => {
    if (!this.value) {
      this.errors.push({ message })
    }

    return this
  }

  bigger = (limit: number, message: string): this => {
    if (this.value <= limit) {
      this.errors.push({ message })
    }

    return this
  }

  mobile = (message: string): this => {
    const phoneRegex = /^(\+?\d{1,3}[- ]?)?(0\d{1,2}[- ]?)?\d{3,4}[- ]?\d{4}$/

    if (phoneRegex.test(String(this.value))) {
      return this
    }

    this.errors.push({ message })
    return this
  }

  email = (message: string): this => {
    const emailRegex = /^(?!\.)[A-Za-z0-9]+([._%+-]+[A-Za-z0-9]*)*@[A-Za-z0-9-]+(\.[A-Za-z0-9-]+)*\.[A-Za-z]{2,}$/

    if (emailRegex.test(String(this.value))) {
      return this
    }

    this.errors.push({ message })
    return this
  }

  minLength = (length: number, message: string): this => {
    if (this.value.length >= length) {
      return this
    }
    this.errors.push({ message })
    return this
  }

  maxLength = (length: number, message: string): this => {
    if (this.value.length <= length) {
      return this
    }
    this.errors.push({ message })
    return this
  }

  pattern = (pattern: RegExp, message: string): this => {
    if (pattern.test(String(this.value))) {
      return this
    }
    this.errors.push({ message })
    return this
  }

  custom = (validator: (value: any) => boolean, message: string): this => {
    if (validator(this.value)) {
      return this
    }
    this.errors.push({ message })
    return this
  }

  trueOrFalse = (message: string): this => {
    if (this.value === true || this.value === false) {
      return this
    }
    this.errors.push({ message })
    return this
  }

  getErrors = (): ValidateError[] => {
    return this.errors
  }
}

export const validate = (value: any): ValidationChain => {
  return new ValidationChain(value)
}
